import React from 'react';
import FactorTabLayout from '../shared/FactorTabLayout';
import { getTab } from '../config';

/**
 * Employment data and labour market conditions.
 *
 * Currently the shared factor layout with nothing extra. Add tab-specific
 * sections as children of FactorTabLayout - they stay isolated to this file.
 */
const UnemploymentTab = ({ data, period }) => (
  <FactorTabLayout tab={getTab('unemployment')} data={data} period={period} />
);

export default UnemploymentTab;
